import React from 'react';
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import Navbar from './components/Navbar';
import Footer from './components/Footer';
import Home from './pages/Home';
import About from './pages/About';
import Services from './pages/Services';
import Contact from './pages/Contact';
import Login from './pages/Login';
import SignUp from './pages/SignUp';
import ForgotPassword from './pages/ForgotPassword';
import UpdatePassword from './pages/UpdatePassword';
import Cowork from './pages/Cowork';
import ProtectedRoute from './components/ProtectedRoute';

function App() {
    return (
        <Router>
            <div className="min-h-screen bg-white flex flex-col">
                <Navbar />
                <main className="flex-1">
                    <Routes>
                        <Route path="/" element={<Home />} />
                        <Route path="/about" element={<About />} />
                        <Route path="/services" element={<Services />} />
                        <Route path="/contact" element={<Contact />} />
                        <Route path="/cowork/login" element={<Login />} />
                        <Route path="/cowork/signup" element={<SignUp />} />
                        <Route path="/cowork/forgot-password" element={<ForgotPassword />} />
                        <Route path="/cowork/update-password" element={<UpdatePassword />} />
                        <Route 
                            path="/cowork" 
                            element={
                                <ProtectedRoute>
                                    <Cowork />
                                </ProtectedRoute>
                            } 
                        />
                    </Routes>
                </main>
                <Footer />
            </div>
        </Router>
    );
}

export default App;